<template>
  <div id="spellChecker" :class="{modal: true, 'is-active': isActive}">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Орфография: {{lang.desc}}</p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body" v-html="text">
      </section>
      <footer class="modal-card-foot">
        <div class="level" style="width:100%">
          <span v-if="hasSuggests == false && isLoading == false"><font-icon icon="check"/> Не найдено не одной ошибки...</span>
          <div v-else/>
          <button ref="acceptButton" class="button is-success level-right" :class="{'is-loading': isLoading}" @click="save">
            <span v-if="hasSuggests">Сохранить</span>
            <span v-else>Закрыть</span>
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "spellChecker",
  data() {
    return {
      isActive: false,
      isLoading: true,
      hasSuggests: false,
      text: "",
      lang: {}
    };
  },
  methods: {
    show: function(text, lang) {
      this.lang = lang;
      this.text = text.replace(/(?:\r\n|\r|\n)/g, "<br>");
      this.isLoading = true;

      this.$http
        .post(
          "https://home.anufrij.de/translit/spellcheck.php",
          { lang: lang.spell, text: text },
          { emulateJSON: true }
        )
        .then(response => {
          this.hasSuggests = response.data.length > 0;
          if (this.hasSuggests) {
            this.replaceSuggests(response.data);
            this.$nextTick(() =>
              document.querySelector(".modal-card-body > select").focus()
            );
          }
          this.isLoading = false;
        });

      this.isActive = true;
      this.$nextTick(() => this.$refs.acceptButton.focus());
    },
    close: function() {
      this.isActive = false;
      this.$emit("closed");
    },
    save: function() {
      let selects = document
        .getElementById("spellChecker")
        .getElementsByTagName("select");
      let return_value = this.text;
      for (let i = 0; i < selects.length; i++) {
        let select = selects[i];
        let regex = new RegExp(
          "<select id='" +
            select.id +
            "'>(<option( selected)?>((?!<).)*</option>)*</select>"
        );
        return_value = return_value.replace(regex, select.value);
      }
      return_value = return_value.replace(/<br>/g, "\n");
      this.$emit("saved", return_value);
      this.close();
    },
    replaceSuggests: function(suggests) {
      suggests.forEach(suggest => {
        let html =
          "<select id='" +
          suggest.word +
          "'><option selected>" +
          suggest.word +
          "</option>";
        suggest.suggest.forEach(alt => {
          html += "<option>" + alt + "</option>";
        });
        html += "</select>";

        let symbols =
          "(\\s|\\?|\\!|\\.|\\,|\\:|\\;|\\§|\\%|\\€|\\(|\\)|\\/|\\$|\\&)";
        let symbol_start = "";
        let symbol_end = "";

        console.log(suggest.word);
        //One word
        let regex = new RegExp("^" + suggest.word + "(" + symbols + "*)$");
        let regexresult = regex.exec(this.text);
        console.log("One word:");
        console.log(regexresult);
        if (regexresult != null) {
          if (regexresult.length > 1) {
            symbol_end = regexresult[1];
          }
          this.text = this.text.replace(regex, html + symbol_end);
          return;
        }

        //First line one word
        regex = new RegExp("^" + suggest.word + "(" + symbols + "*)<br>");
        regexresult = regex.exec(this.text);
        console.log("First line one word:");
        console.log(regexresult);
        if (regexresult != null) {
          if (regexresult.length > 1) {
            symbol_end = regexresult[1];
          }
          this.text = this.text.replace(regex, html + symbol_end + "<br>");
          return;
        }

        //First word of whole text
        regex = new RegExp("^" + suggest.word + symbols);
        regexresult = regex.exec(this.text);
        console.log("First word of whole text:");
        console.log(regexresult);
        if (regexresult != null) {
          if (regexresult.length > 1) {
            symbol_end = regexresult[1];
          }
          this.text = this.text.replace(regex, html + symbol_end);
          return;
        }

        //First word of a line
        regex = new RegExp("<br>" + suggest.word + "(" + symbols + "+)");
        regexresult = regex.exec(this.text);
        console.log("First word of a line:");
        console.log(regexresult);
        if (regexresult != null) {
          symbol_end = regexresult[1];
          this.text = this.text.replace(regex, "<br>" + html + symbol_end);
          return;
        }

        //All words into a text
        regex = new RegExp(symbols + suggest.word + symbols);
        regexresult = regex.exec(this.text);
        console.log("All words into a text:");
        console.log(regexresult);
        if (regexresult != null) {
          symbol_start = regexresult[1];
          symbol_end = regexresult[2];

          this.text = this.text.replace(
            regex,
            symbol_start + html + symbol_end
          );
          return;
        }

        //Last word of a line
        regex = new RegExp(" " + suggest.word + "(" + symbols + "*)<br>");
        regexresult = regex.exec(this.text);
        console.log("Last word of a line:");
        console.log(regexresult);
        if (regexresult != null) {
          if (regexresult.length > 1) {
            symbol_end = regexresult[1];
          }
          this.text = this.text.replace(
            regex,
            " " + html + symbol_end + "<br>"
          );
          return;
        }

        //One line one word
        regex = new RegExp("<br>" + suggest.word + "(" + symbols + "*)<br>");
        regexresult = regex.exec(this.text);
        console.log("One line one word:");
        console.log(regexresult);
        if (regexresult != null) {
          if (regexresult.length > 1) {
            symbol_end = regexresult[1];
          }
          this.text = this.text.replace(
            regex,
            "<br>" + html + symbol_end + "<br>"
          );
          return;
        }

        //Last word of whole text
        regex = new RegExp(
          symbols + "+" + suggest.word + "(" + symbols + "*)$"
        );
        regexresult = regex.exec(this.text);
        console.log("Last word of whole text:");
        console.log(regexresult);
        if (regexresult != null) {
          symbol_start = regexresult[1];
          if (regexresult.length > 2) {
            symbol_end = regexresult[2];
          }
          this.text = this.text.replace(
            regex,
            symbol_start + html + symbol_end
          );
          return;
        }

        //Last line one word
        regex = new RegExp("<br>" + suggest.word + "(" + symbols + "*)$");
        regexresult = regex.exec(this.text);
        console.log("Last line one word:");
        console.log(regexresult);
        if (regexresult != null) {
          if (regexresult.length > 1) {
            symbol_end = regexresult[1];
          }
          this.text = this.text.replace(regex, "<br>" + html + symbol_end);
          return;
        }
      });
    }
  }
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// app/translit/src/components/spellChecker.vue